<template>
  <div class="HomePage">
    <el-container>
      <Header ref="header" />
      <el-main :style="'min-height:' + mainHeight + 'px'">
        <router-view></router-view>
      </el-main>
      <!-- Footer -->
      <el-footer>
        <Footer ref="footer" />
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import Header from '@/components/Container/Header'
import Footer from '@/components/Container/Footer'
export default {
  name: 'HomePage',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      mainHeight: 0
    }
  },
  created() {},
  mounted() {
    let headerHeight = this.$refs.header.$el.offsetHeight
    let footerHeight = this.$refs.footer.$el.offsetHeight
    // console.log(this.$refs.header.$el.offsetHeight)
    // console.log(this.$refs.footer.$el.offsetHeight)
    let mainHeight = document.documentElement.clientHeight - headerHeight - footerHeight
    this.mainHeight = mainHeight - 22
  },
  methods: {}
}
</script>

<style lang="scss">
$themeColor: #4f8dfe;
.HomePage {
  .el-main {
    position: relative;
    margin-top: 80px;
    @media screen and (max-width: 414px) {
      margin-top: 0;
      // padding-top: 13vw;
    }
  }
}
</style>
